<template>
  <v-container grid-list-md fluid>
    <new-appointment @saved="getAppointments" :visibility.sync="newFormVisible" />
    <v-layout row wrap>
      <v-flex xs12>
        <div class="section-title di-flex align-center justify-space-between">
          <span>Appointments</span>
          <div style="width: 50%;">
            <v-text-field
              v-debounce:500ms="getAppointments"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              class="rounded"
              label="Search"
              hide-details
              single-line
              outline
            >
              <v-tooltip top slot="append-outer">
                <v-icon
                  class="mx-2"
                  medium
                  slot="activator"
                  @click="newApp"
                  color="secondary"
                >mdi-plus-circle</v-icon>

                <span>New Appointment</span>
              </v-tooltip>
            </v-text-field>
          </div>

          <!-- <v-btn @click="newApp" small color="secondary" icon class="ma-0 shadow">
            <v-icon small>mdi-plus</v-icon>
          </v-btn>-->
        </div>

        <v-data-table
          :headers="headers"
          :items="apps.data"
          disable-initial-sort
          :pagination.sync="pagination"
          :total-items="apps.meta.total"
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{item}">
            <tr>
              <td>{{ item.patient ? item.patient.name : ''}}</td>
              <td>{{ item.doctor ? item.doctor.name: '' }}</td>
              <td>{{ item.date  | moment('YYYY-MM-DD')}}</td>
              <td>{{ item.fee | currency('AFN') }}</td>
              <td class="text-capitalize" :class="item.status">{{ item.status }}</td>
              <td>
                <v-icon
                  v-if="item.status !== 'done'"
                  @click="deleteAppointment(item)"
                >mdi-delete-outline</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NewAppointment from "./new.vue";
export default {
  middleware: "reception",
  components: {
    NewAppointment
  },
  data() {
    return {
      apps: {
        data: [],
        meta: {},
        links: {}
      },
      newFormVisible: false,
      pagination: {
        descending: true
      },
      headers: [
        { text: "Patient", value: "patient.name", sortable: false },
        { text: "Doctor", value: "doctor.name", sortable: false },
        { text: "Date", value: "date" },
        { text: "Fee", value: "fee" },
        { text: "Status", value: "status" },
        { text: "", value: "status", sortable: false }
      ],
      search: ""
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getAppointments();
      }
    }
  },
  methods: {
    getAppointments() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      let query = `/api/appointments?rows_per_page=${rowsPerPage}&search=${encodeURIComponent(
        this.search
      )}&page=${page}`;

      if (sortBy) query = `${query}&sort_by=${sortBy}`;
      if (descending !== null) query = `${query}&desc=${descending ? 1 : 0}`;
      

      this.getDataFromApi(query);
    },

    async getDataFromApi(path) {
      const { data } = await this.axios.get(path);
      if (data) this.apps = data;
    },

    newApp() {
      this.newFormVisible = true;
    },
    async deleteAppointment(app) {
      this.$modal.show({
        message: `Are you sure, you want to delete this appointment?`,
        mode: "delete",
        onConfirm: () => {
          this.axios
            .delete(`/api/appointments/${app.id}`)
            .then(result => {
              this.getAppointments();
            })
            .catch(err => {
              this.$snackbar.error("Could not delete this appointment");
            });
        }
      });
    }
  }
};
</script>
<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
</style>

